import axios from "axios";

export const state = {
  articles: [],

}

// dispatch
export const actions = {
  getArticles: ({ commit }) => {
    axios

      .post('/api/pcs/documentation', {
        params: {
          pcs: localStorage.getItem('pcs'),
        },
      })
      .then(response => {
        commit('GET_ARTICLES', response.data)
      })
  },
  initNotes: ({ commit }, tabs) => {
    commit('INIT_NOTES', tabs)
  },
  populateFromDB: async ({ commit, dispatch, state }, payload) => {},
}

// commit
export const mutations = {
  GET_ARTICLES: (state, value) => {

    state.articles = value.articles
  },
}
